// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "idd-cb66d.firebaseapp.com",
  "projectId": "idd-cb66d",
  "storageBucket": "idd-cb66d.firebasestorage.app",
  "messagingSenderId": "233877266507",
  "appId": "1:233877266507:web:5074dc362d8baf1d88edce",
  "measurementId": "G-80Y0ZPJ9H4",
  "apiKey": "AIzaSyDqdGTGppGblX18pIA_PJsd4bvi4W8ocJg"
};
